export const environment = {
  production: true,
  apiUrl: 'https://api.toolidi.ir/api',
  publicSiteUrl: 'https://api.toolidi.ir/',
  siteName: 'تولیدی'
};
